<div class="notification-bell-container">
  <p-button appGlobalLoadingDisable 
    icon="pi pi-bell" 
    [rounded]="true"
    [text]="true"
    [badge]="(unreadCount$ | async)?.toString() || ''"
    badgeSeverity="danger"
    pTooltip="Notifications"
    tooltipPosition="bottom"
    (onClick)="notificationDrawerVisible = true"
    [attr.aria-label]="'Notifications' + ((unreadCount$ | async) ? ', ' + (unreadCount$ | async) + ' unread' : '')"
    [attr.aria-expanded]="notificationDrawerVisible"
    [attr.aria-haspopup]="true">
  </p-button>

  <p-drawer 
    [(visible)]="notificationDrawerVisible" 
    [position]="'right'" 
    styleClass="!w-full md:!w-[30rem] lg:!w-[30rem]"
    header="Notifications"
    role="dialog"
    [attr.aria-label]="'Notifications panel'"
    (onShow)="onDrawerOpen()">
    <ng-template pTemplate="content">
      <div class="notification-panel" role="region" aria-label="Notification list" i18n-aria-label>
      <!-- Header -->
      <div class="notification-header">
        <h3 class="notification-title" id="notifications-heading">
          <i class="pi pi-bell" aria-hidden="true"></i>
          Notifications
        </h3>
        <div class="notification-actions">
          <button 
            *ngIf="(unreadCount$ | async)! > 0"
            pButton 
            type="button"
            label="Mark all read" 
            class="p-button-text p-button-sm"
            (click)="markAllAsRead()"
            aria-label="Mark all notifications as read" i18n-aria-label>
          </button>
        </div>
      </div>

      <!-- Notification List -->
      <div class="notification-scroll">
        <ul 
          class="notification-list" 
          *ngIf="!loading"
          role="list"
          aria-labelledby="notifications-heading">
          <!-- Empty state -->
          <li *ngIf="notifications.length === 0" class="empty-state" role="status">
            <i class="pi pi-bell-slash" aria-hidden="true"></i>
            <p i18n>No notifications</p>
          </li>

          <!-- Notification items -->
          <li 
            *ngFor="let notification of notifications; let i = index" 
            class="notification-item"
            [class.unread]="!notification.isRead"
            role="listitem">
            <button
              type="button"
              class="notification-button"
              (click)="handleNotificationClick(notification)"
              [attr.aria-label]="notification.title + '. ' + notification.message + '. ' + getTimeAgo(notification.createdAt) + (notification.isRead ? '' : '. Unread')">
              
              <!-- Icon -->
              <div class="notification-icon" [class]="getPriorityClass(notification.priority)">
                <i [class]="getIconClass(notification)" aria-hidden="true"></i>
              </div>
              
              <!-- Content -->
              <div class="notification-content">
                <h4 class="notification-item-title">
                  <span *ngIf="!notification.isRead" class="unread-badge-inline" i18n>NEW</span>
                  {{ notification.title }}
                </h4>
                <p class="notification-message">{{ notification.message }}</p>
                <span class="notification-time">{{ getTimeAgo(notification.createdAt) }}</span>
              </div>
              
              <!-- Action button -->
              <div class="notification-action" *ngIf="notification.metadata?.actionUrl" aria-hidden="true">
                <i class="pi pi-arrow-right"></i>
              </div>

              <!-- Unread dot indicator -->
              <div class="unread-indicator" *ngIf="!notification.isRead" aria-hidden="true" title="Unread"></div>
            </button>
          </li>
        </ul>

        <!-- Loading state -->
        <div *ngIf="loading" class="loading-state" role="status" aria-live="polite">
          <i class="pi pi-spinner pi-spin" aria-hidden="true"></i>
          <p>Loading notifications...</p>
        </div>
      </div>

      <!-- Footer -->
      <div class="notification-footer">
        <button 
          pButton 
          type="button"
          label="View All Notifications" 
          class="p-button-text p-button-sm"
          (click)="viewAllNotifications(); notificationDrawerVisible = false"
          aria-label="View all notifications page">
        </button>
      </div>
    </div>
    </ng-template>
  </p-drawer>
</div>

